import { useStore } from 'vuex';

export default function useFacetUrl() {
  const store = useStore();
  const metaBaseUrl = store.getters.getFacetMetaBaseUrl;
  const pageData = store.getters.getAnalyticsData;
  const categoryID = pageData?.categoryID || null;

  function generateFacetUrl(url) {
    let path = '';
    /* istanbul ignore else */
    if (categoryID !== null) {
      if (categoryID !== 'onsite_search' && categoryID !== 'DLP') {
        path = `${metaBaseUrl}${url}?id=${categoryID}`;
      } else {
        path = `${metaBaseUrl}${url}`;
      }
    }
    return path;
  }

  return { generateFacetUrl };
}
